import { BrandMark } from "./BrandMark";
import { VolumePulse } from "./VolumePulse";
import { Spotlight } from "./Spotlight";
import { TopCorridors } from "./TopCorridors";
import { TopMerchants, type MerchantStat } from "./TopMerchants";
import { WalletActivity } from "./WalletActivity";
import type { Mode } from "../modes/orchestrator";
import type { CorridorStat, SpotlightEvent } from "../data/types";
import type { TodayTotals, DisplayStats, DataFreshness } from "../data/replay";

export function Overlays(props: {
  mode: Mode;
  todayTotals: TodayTotals | null;
  corridors: CorridorStat[];
  merchants: MerchantStat[];
  spotlight: SpotlightEvent | null;
  displayStats: DisplayStats | null;
  freshness: DataFreshness | null;
}) {
  return (
    <div className="overlays">
      <div className="corner top-left">
        <VolumePulse totals={props.todayTotals} displayStats={props.displayStats} />
      </div>
      <div className="corner top-right">
        <TopCorridors corridors={props.corridors} />
        <TopMerchants merchants={props.merchants} />
      </div>
      <div className="corner bottom-left">
        <WalletActivity totals={props.todayTotals} />
      </div>
      <div className="corner bottom-center">
        <Spotlight event={props.spotlight} />
      </div>
      <div className="corner bottom-right">
        <BrandMark
          mode={props.mode}
          displayStats={props.displayStats}
          freshness={props.freshness}
        />
      </div>
    </div>
  );
}
